<template>
    <section class="section login whitespace-first-section" v-if="pageData">
        <div class="container">
            <div class="column-wrapper half-half">
                <div class="column content">
                    <figure>
                        <img class="logo" alt="Logo" src="@/assets/svgs/logo.svg" />
                    </figure>
                    <div class="inner-wrapper">
                        <h1 class="column-title" v-if="pageData.headerTitle && pageData.headerTitle !== ''">
                            {{ pageData.headerTitle }}
                        </h1>
                        <div class="column-txt" v-if="pageData.headerIntroText && pageData.headerIntroText !== ''"
                            v-html="pageData.headerIntroText"></div>

                        <nav class="buttons-wrapper"
                            v-if="pageData.headerButtonUrl && pageData.headerButtonUrl !== '' || pageData.headerSecondButtonUrl && pageData.headerSecondButtonUrl !== ''">
                            <ul class="mini-wrapper">
                                <li v-if="pageData.headerButtonLabel && pageData.headerButtonLabel !== ''">
                                    <a class="button" :href="pageData.headerButtonUrl" target="_blank">
                                        {{ pageData.headerButtonLabel }}
                                    </a>
                                </li>
                                <li v-if="pageData.headerSecondButtonLabel && pageData.headerSecondButtonLabel !== ''">
                                    <a class="button hollow-btn" :href="pageData.headerSecondButtonUrl" target="_blank">
                                        {{ pageData.headerSecondButtonLabel }}
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <FaqCollection :filterFaqBy="['Account questions']">
                            <!-- <h2 class="section-title">Frequently asked questions</h2>
                                <span class="section-subtitle">Before you contact us, maybe you can find your answer
                                    here?</span> -->
                        </FaqCollection>
                    </div>
                </div>
                <div class="column form popup-looks">
                    <div class="title-wrapper">
                        <h2 class="column-title">Account activation</h2>
                        <p class="subtitle">Fill in the form to create your account</p>
                    </div>
                    <ActivateAccountForm />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    fetchPageBySlug,
    clearData
} from "@streampac.io/chef_sp_1";

//@import component
import ActivateAccountForm from "@/components/Forms/ActivateAccountForm";

export default {
    data() {
        return {
            pageData: null,
        };
    },
    components: {
        ActivateAccountForm,
    },
    inject: ["isAuthenticated", "setAuthenticated"],
    created() {
        if (this.isAuthenticated) {
            this.handleLogout();
        } else {
            this.fetchPage();
        }
    },
    methods: {
        fetchPage() {
            fetchPageBySlug(this.isAuthenticated, "activate-account").then(
                (response) => {
                    this.pageData = response;

                    if (response.headerImage && response.headerImage !== '') {
                        let bgUrl = response.headerImageModel.url;
                        this.$store.commit("saveBodyBackgroundUrl", bgUrl);
                    }
                }
            );

        },
        handleLogout() {
            clearData();
            this.setAuthenticated(false);
            this.$store.commit("storeRemoveAuthenticatedStatus");
            this.$store.commit("deleteUserSavedData");
            // this.$router.replace({ name: "Home" });
            window.location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
